"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/pui-react-lists/~/babel-runtime/helpers/classCallCheck.js
// module id = 3219
// module chunks = 0